// import 'react-toastify/dist/ReactToastify.css';
// import { ToastContainer } from "react-toastify";
// import router from "./Routes/Router";
// import "./App.css";
// import "./Styles/custom.css";
// import { RouterProvider } from "react-router-dom";
// import { useEffect } from 'react';

// function App() {

//   useEffect(() => {
//     const existingMainScript = document.querySelector(
//       'script[src="http://stoneskill.com/assets/js/main.js?v=5.3"]'
//     );
//     const existingShopScript = document.querySelector(
//       'script[src="http://stoneskill.com/assets/js/shop.js?v=5.3"]'
//     );

//     if (!existingMainScript) {
//       const script1 = document.createElement("script");
//       script1.src = "http://stoneskill.com/assets/js/main.js?v=5.3";
//       script1.async = true;
//       document.body.appendChild(script1);
//     }

//     if (!existingShopScript) {
//       const script2 = document.createElement("script");
//       script2.src = "http://stoneskill.com/assets/js/shop.js?v=5.3";
//       script2.async = true;
//       document.body.appendChild(script2);
//     }

//     return () => {
//       if (existingMainScript) document.body.removeChild(existingMainScript);
//       if (existingShopScript) document.body.removeChild(existingShopScript);
//     };
//   }, []);

//   useEffect(() => {
//     setTimeout(() => {
//       const script = document.createElement('script');
//       script.src = 'https://stoneskill.com/assets/js/main.js?v=5.3';
//       script.async = true;
//       document.body.appendChild(script);
//     }, 200);
//   }, []);
//   return (
//     <>
//       <ToastContainer />
//       <div className="App">
//         <RouterProvider router={router} />
//       </div>
//     </>
//   );
// }

// export default App;


import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from "react-toastify";
import router from "./Routes/Router";
import "./App.css";
import "./Styles/custom.css";
import { RouterProvider } from "react-router-dom";
import { useEffect } from 'react';

function App() {
  // useEffect(() => {
  //   const scriptUrls = [
  //     "http://stoneskill.com/assets/js/main.js?v=5.3",
  //     "http://stoneskill.com/assets/js/shop.js?v=5.3"
  //   ];

  //   const addedScripts = [];

  //   scriptUrls.forEach(url => {
  //     if (!document.querySelector(`script[src="${url}"]`)) {
  //       const script = document.createElement("script");
  //       script.src = url;
  //       script.async = true;
  //       script.onload = () => console.log(`${url} loaded successfully`);
  //       document.body.appendChild(script);
  //       addedScripts.push(script);
  //     }
  //   });

  //   return () => {
  //     addedScripts.forEach(script => {
  //       document.body.removeChild(script);
  //     });
  //   };
  // }, []);

  return (
    <>
      <ToastContainer />
      <div className="App">
        <RouterProvider router={router} />
      </div>
    </>
  );
}

export default App;
